import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class AssignClass extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			 id : '',
			user : '',
			cls : '',
			_message : '',
			alertClass :'',
			value : [],
			data :[],
			posts : [],
			types : [],
		  _redirect : false,
		}
		this.onChange = this.onChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	/** reset the form **/
	onClick(e){
		
		document.getElementById("clsform").reset();
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('assignclass/deleteassignclass',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Assign Class Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Assign Class',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.user && this.state.value){
			
			PostData('assignclass/add',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Class Assign Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("clsform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getclass();
		this.getusertype();
		this.getdata();
	}
	
	/** get Data **/
	getdata(){
		
		GetData('assignclass/getassigndet').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
	  
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get usertype **/
	getusertype(){
		
		GetData('usertype/getusertype').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					types : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/view/editclass/' + this.state.idd} />);

	}
	 
	var items = this.state.posts;
	
	var utype = this.state.types;
	
	/** map class value to react multi select **/
	var val = this.state.posts.map(function(e,key) {
	   return (
		 {value : e.id, label : e.class }
	   );
	});
	
    return (
		<div className="animated fadeIn">
			<Row>
			  <Col md="6">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Card>
				  <form action="" method="post" role="form" id="clsform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Assign Class</strong>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Users <span className="text-danger">*</span></Label>
							  <select name="user" onChange={this.onChange} className="form-control" required>
								<option value="">Select Usertype</option>
								{
									utype.map(function (item) {
										return <option value={item.id }>{item.usertype}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
							  <Select value={this.state.value} onChange={this.handleChange} multi options={val} required />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			  <Col md="6">
				<Card>
				  <CardBody>
				    <Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>User Type</th>
								<th width="100">Class</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.data.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.username}</td>
									<td>{item.classname}</td>
									<td>
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						</tbody>
					</Table>
				  </CardBody>
				</Card>
			  </Col>
			</Row>
		</div>
	);
  }
}

export default AssignClass;



// WEBPACK FOOTER //
// ./src/settings/AssignClass/AssignClass.js